import moment from "moment";

export const PAGE_SIZE = 50;

export const formatDateTime = (value) =>
  value ? moment(value).format("YYYY-MM-DD HH:mm") : "-";
